module.exports = __webpack_public_path__ + "img/fail_pic@2x.78490426.png";